import jQuery from 'jquery';

export default function videoTogller() {
    jQuery(() => {
        jQuery('video').each(function () {
            if (this.getAttribute('autoplay')) {
                jQuery(this)
                    .after('<a href="#" class="video__play-pause" title="play">Play</a>');
            }
        });


        jQuery('body')
            .on('click', '.video__play-pause', (e) => {
                e.preventDefault();
                const $that = jQuery(e.currentTarget);
                const video = e.currentTarget.previousElementSibling;
                const $title = ($that.attr('title') === 'play') ? 'pause' : 'play';
                $that.toggleClass('paused');
                $that.attr('title', $title);

                if (video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2) {
                    video.pause();
                } else {
                    video.play();
                }
            });
    });
}
